module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-13.e4b3df53.png";